<script>

    import ShipmentsService from '../$services/shipments.service'
    import DateMethod from '../$methods/date.method'
    import Button from '../$components/button.svelte'

    let loading = false
    let element

    async function getShipmentsTracingReport() {
    
        loading = true
        const blob = await ShipmentsService.getShipmentsTracingReport()
        loading = false

        if(!blob)
            toast({message: resp.error.message, type: 'is-danger'})

        let fileName = `${ DateMethod.dateShort() }_envios_revision`

        element.download = `${fileName}.xlsx`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }
</script>

<a bind:this={element} style="display: none;" href="/">.</a>
<Button on:click={getShipmentsTracingReport} text="Descargar" icon="file-download" { loading } />